import { useQuery } from "@tanstack/react-query";
import { fetchGamificationFilterList } from "../services/gamificationService";

const DEFAULT_FILTER = {
  key: "",
  name: "All Activities",
};

function normalizeFilter(item) {
  return {
    key: String(item?.key || "").trim(),
    name: String(item?.name || "").trim() || "Activity",
    raw: item,
  };
}

export function useGamificationFilterList(options = {}) {
  return useQuery({
    queryKey: ["gamificationFilterList"],
    queryFn: async () => {
      const { payload } = await fetchGamificationFilterList();
      const filters = Array.isArray(payload?.activities)
        ? payload.activities.map(normalizeFilter).filter((item) => item.key)
        : [];

      return {
        filters: [DEFAULT_FILTER, ...filters],
      };
    },
    enabled: options.enabled ?? true,
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        filters: [DEFAULT_FILTER],
      },
  });
}

export { DEFAULT_FILTER as DEFAULT_GAMIFICATION_ACTIVITY_FILTER };
